// extracted by mini-css-extract-plugin
export default {"list":"ProjectProfilesList_list__m3sIW","loaderBox":"ProjectProfilesList_loaderBox__DI14Z"};